/**
 * Component: Site navigation
 * ------------------------------------------------------------------------------
 * The meganav dropdown for vehicles.
 *
 * @namespace vehicleCarousel
 */
import log from 'salvo-lite/log'

import debounce from 'lodash-es/debounce'
import cssClasses from '../helpers/cssClasses'
import { on } from '../helpers/utils'

class VehicleCarousel {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        /**
         * DOM this._selectors.
         */
        this._selectors = {
            sectionContainer: '[js-vehicle="container"]',
            navCarousel: '[js-nav-carousel="container"]',
            navCarouselCell: '[data-component-id="vehicle-nav-carousel"]',
            categoryTab: '[js-vehicle-types="tab"]',
            categoryTabState: '[js-vehicles-tab="state"]',
            categoryBlock: '[js-vehicle-types="block"]',
            carouselContainer: '[data-component-id*="vehicle-carousel"]',
            carouselCell: '[js-vehicle-carousel-cell="cell"]',
            carouselAttribute: 'data-component-id',
            tabAttribute: 'data-tab',
            mobileTab: '[data-mobile-tab]'
        }
        /**
         * DOM node selectors.
         */
        this._nodeSelectors = {
            sectionContainer: document.querySelector(this._selectors.sectionContainer),
            categoryTab: [...document.querySelectorAll(this._selectors.categoryTab)],
            categoryBlock: [...document.querySelectorAll(this._selectors.categoryBlock)],
            carouselContainer: [...document.querySelectorAll(this._selectors.carouselContainer)],
            carouselCell: [...document.querySelectorAll(this._selectors.carouselCell)],
            categoryTabState: document.querySelector(this._selectors.categoryTabState),
            mobileTab: document.querySelector(this._selectors.mobileTab),
            navCarousel: document.querySelector(this._selectors.navCarouselCell)
        }

        this._navCarouselComponent = this._theme.getComponentsById('vehicle-nav-carousel')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
     * Initialise component.
     */
    onInit () {
        if (!this._nodeSelectors.sectionContainer) {
            return
        }

        this._setDefaultState()
        this._setEventListeners()
        this._handleMobileDropdown()
        this._dragScroll()
    }

    /**
     * Set default state based on screen size.
     */
    _setDefaultState () {
        this._setActiveTabIndicator()
    }

    /**
     * Set event listeners.
     */
    _setEventListeners () {
        this._nodeSelectors.categoryTab.forEach((item, index) => {
            on('click', item, (event) => {
                const itemAttribute = item.getAttribute(this._selectors.tabAttribute)
                this._handleNavToggle(item, event, itemAttribute)
                this._setMobileActiveTab(item.innerHTML)

                this._nodeSelectors.categoryTabState.style.width = `${item.offsetWidth}px`
                this._nodeSelectors.categoryTabState.style.left = `${item.offsetLeft}px`
            })
        })

        on('resize', debounce(() => {
            this._setActiveTabIndicator()
        }, 250))
    }

    _setMobileActiveTab (selectedTab) {
        this._nodeSelectors.mobileTab.innerHTML = ''
        this._nodeSelectors.mobileTab.innerHTML = selectedTab
        this._nodeSelectors.navCarousel.classList.toggle('active')
    }

    _handleMobileDropdown () {
        this._nodeSelectors.mobileTab.addEventListener('click', () => {
            this._nodeSelectors.navCarousel.classList.toggle('active')
        })
    }

    _dragScroll () {
        const slider = this._nodeSelectors.navCarousel
        let mouseDown = false
        let startX, scrollLeft

        let startDragging = function (e) {
            mouseDown = true
            startX = e.pageX - slider.offsetLeft
            scrollLeft = slider.scrollLeft
        }
        let stopDragging = function (event) {
            mouseDown = false
        }

        slider.addEventListener('mousemove', (e) => {
            e.preventDefault()
            if (!mouseDown) { return }
            const x = e.pageX - slider.offsetLeft
            const scroll = x - startX
            slider.scrollLeft = scrollLeft - scroll
        })

        // Add the event listeners
        slider.addEventListener('mousedown', startDragging, false)
        slider.addEventListener('mouseup', stopDragging, false)
        slider.addEventListener('mouseleave', stopDragging, false)
    }

    /**
     * Vehicle carousel nav toggle functions.
     * @param {Object} item the clicked element.
     * @param {Event} event the click event.
     * @param {String} attribute the attribute of the clicked element.
     */
    _handleNavToggle (item, event, attribute) {
        event.preventDefault()

        if (!item.classList.contains(cssClasses.active)) {
            this._removeActiveElements()
            item.classList.add(cssClasses.active)
        }

        this._nodeSelectors.categoryBlock.forEach((element) => {
            const elementAttribute = element.getAttribute(this._selectors.tabAttribute)

            if (elementAttribute === attribute) {
                element.classList.add(cssClasses.active)
            }
        })
    }

    /**
     * Remove active classes from all nav items and content blocks.
     */
    _removeActiveElements () {
        this._nodeSelectors.categoryTab.forEach((element) => {
            element.classList.remove(cssClasses.active)
        })

        this._nodeSelectors.categoryBlock.forEach((element) => {
            element.classList.remove(cssClasses.active)
        })
    }

    /**
     * Set position for active tab indicator.
     */
    _setActiveTabIndicator () {
        this._nodeSelectors.categoryTab.forEach((item) => {
            if (!item.classList.contains(cssClasses.active)) {
                return
            }

            if (item.classList.contains(cssClasses.active)) {
                this._nodeSelectors.mobileTab.innerHTML = item.innerHTML
            }

            this._nodeSelectors.categoryTabState.style.width = `${item.offsetWidth}px`
            this._nodeSelectors.categoryTabState.style.left = `${item.offsetLeft}px`
        })
    }
}

export default VehicleCarousel



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VehicleCarousel.js